import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const isValidId = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  value !== "null" &&
  value !== "undefined";

export const useActiveConsultationSickCert = (consultationId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["activeConsultationSickCert", tenantVal, consultationId],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientsickcert/getbyconsultationid/${consultationId}`
      );

      return response.data;
    },
    enabled: isValidId(consultationId) && !!tenantVal,
  });
};
